import { Controller } from "@hotwired/stimulus"

// When the cold "scan the org" preview can't be shown — the lazy frame resolves to the fallback
// (unmapped domain, empty/failed roster, budget out, timeout) — the pane is swapped for the same
// three-step promise the plain sign-up page shows, so the pitch column never sits half-empty.
//
// The fallback partial carries a [data-cold-split-target="collapse"] marker; when it lands in the
// frame, collapseTargetConnected fires.
export default class extends Controller {
  static targets = ["pane", "fallback", "collapse"]

  collapseTargetConnected() {
    if (this.hasPaneTarget && this.hasFallbackTarget) {
      this.paneTarget.replaceWith(this.fallbackTarget.content.cloneNode(true))
    } else if (this.hasPaneTarget) {
      this.paneTarget.remove()
    }
  }
}
